import React, { useState, useEffect } from 'react';
import { TailSpin } from  'react-loader-spinner';
import { useParams, useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';
import axios from 'axios';

// Constants
import SftGlobalData from '../library/SftGlobalData';
import Colors from '../library/Colors';

// Components
import CardSliderWithImage from '../components/CardSliderWithImage';
import ApplicationContainer from '../components/ApplicationContainer';

// Assets
import testLogo from '../assets/Test.png';
import birthdayLogo from '../assets/module-icons/ic_birthday.png'
import mobileLogo from '../assets/module-icons/ic_mobile.png'
import mailIntegrationsLogo from '../assets/module-icons/ic_mailintegrations.png'
import googleLogo from '../assets/module-icons/ic_google.png'
import facebookLogo from '../assets/module-icons/ic_facebook.png'
import integrationsLogo from '../assets/module-icons/ic_integrations.png'
import excelLogo from '../assets/module-icons/ic_excel.png'
import usersLogo from '../assets/module-icons/ic_users.png'
import licenceIcon from '../assets/module-icons/ic_licence.png';
import shippingIcon from '../assets/module-icons/ic_shipping.png';
import eticketLogo from '../assets/module-icons/ic_eticket.png';
import inventoryLogo from '../assets/mobile-icons/ic_inventory.png'
import settingLogo from '../assets/mobile-icons/ic_settings.png'
import exactLogo from '../assets/module-icons/ic_exact.png';
import geminiLogo from '../assets/module-icons/ic_ai.png';
import webshopLogo from '../assets/module-icons/ic_webshop.png';
import rmaLogo from '../assets/module-icons/ic_rma.png';
import schedulerLogo from '../assets/module-icons/ic_scheduler.png';
import customerDisplayLogo from '../assets/module-icons/ic_customer_display.png';
import peppolLogo from '../assets/module-icons/ic_peppol.png';

import ic_mysft from '../assets/application-icons/ic_mysft.png';
import ic_revenue from '../assets/application-icons/ic_revenue.png';
import RevenueSettingsForm from '../components/RevenueSettingsForm';
import FloatingBackButton from '../components/FloatingBackButton';
import FloatingSaveButton from '../components/FloatingSaveButton';



const UserDetailAppScreen = (props) => {
    const [loading, setLoading] = useState(true);
    let navigate = useNavigate();
    const params = useParams();

    let isUpdated = false;

    // MY SFT
    let mySftActive = false;
    let excelActive = false;
    let mobileActive = false;
    let shippingLogActive = false;
    let userManagementActive = false;
    let customerDisplayActive = false;
    let schedulerActive = false;
    let aiActive = false;
    let eticketActive = false;
    let peppolActive = false;
    let birthdayActive = false;
    let integrationsActive = false;
    let mailIntegrationsActive = false;
    let licenceActive = false;
    let rmaActive = false;
    let webshopActive = false;
    let exactActive = false;

    const generateJsonMySft = () => {
        const jsonObj = {};

        // Only include modules that were originally fetched
        if (originalSettings.modShipping !== undefined) jsonObj.modShipping = (shippingLogActive ? 1 : 0);
        if (originalSettings.modUserManagement !== undefined) jsonObj.modUserManagement = (userManagementActive ? 1 : 0);
        if (originalSettings.modMobile !== undefined) jsonObj.modMobile = (mobileActive ? 1 : 0);
        if (originalSettings.modExcel !== undefined) jsonObj.modExcel = (excelActive ? 1 : 0);
        if (originalSettings.modScheduler !== undefined) jsonObj.modScheduler = (schedulerActive ? 1 : 0);
        if (originalSettings.modCustomerDisplay !== undefined) jsonObj.modCustomerDisplay = (customerDisplayActive ? 1 : 0);
        if (originalSettings.modAi !== undefined) jsonObj.modAi = (aiActive ? 1 : 0);
        if (originalSettings.modEticket !== undefined) jsonObj.modEticket = (eticketActive ? 1 : 0);
        if (originalSettings.modPeppol !== undefined) jsonObj.modPeppol = (peppolActive ? 1 : 0);
        if (originalSettings.modBirthday !== undefined) jsonObj.modBirthday = (birthdayActive ? 1 : 0);
        if (originalSettings.modIntegrations !== undefined) jsonObj.modIntegrations = (integrationsActive ? 1 : 0);
        if (originalSettings.modMailIntegrations !== undefined) jsonObj.modMailIntegrations = (mailIntegrationsActive ? 1 : 0);
        if (originalSettings.modLicence !== undefined) jsonObj.modLicence = (licenceActive ? 1 : 0);
        if (originalSettings.modRma !== undefined) jsonObj.modRma = (rmaActive ? 1 : 0);
        if (originalSettings.modWebshop !== undefined) jsonObj.modWebshop = (webshopActive ? 1 : 0);
        if (originalSettings.modExact !== undefined) jsonObj.modExact = (exactActive ? 1 : 0);

        return JSON.stringify(jsonObj);
    }

    // REVENUE
    let revenueAppActive = false;
    let revenueAppJson = "";

    const setRevenueAppJson = (value) => {
        revenueAppJson = JSON.stringify(value);
        isUpdated = true;
    }
    
    const [apps, setApps] = useState([]);
    const [originalSettings, setOriginalSettings] = useState({});

    // wijzigen - /nl/user-detail/{userId}/{appId}
    // nieuw - /nl/user-detail/{userId}/apps
    // defaults - /nl/app-defaults

    useEffect(() => {
        if(props.api !== ''){
            if(!props.defaults){
                SftGlobalData.post('account&action=fetchOne', {id: params.userId, key: props.api}).then(response => {
                    if(params.appId && params.appId !== "apps"){
                        if(SftGlobalData.debug){
                            console.log("1 app", apps[params.appId-1]);
                        }
                        setApps([response.data.applications[params.appId-1]]);
                    } else {
                        setApps(response.data.applications);
                    }
                    setLoading(false);
                });
            } else {
                SftGlobalData.post('appDefaults&action=fetch', {id: params.userId, key: props.api}).then(response => {
                    setApps(response.data.applications);
                    setLoading(false);
                });
            }
        }
     },[props.api]);

    // Set original settings when apps data is loaded
    useEffect(() => {
        if (apps.length > 0) {
            const mySftApp = apps.find(app => app.id == "1");
            if (mySftApp?.settings) {
                setOriginalSettings(mySftApp.settings);
            }
        }
    }, [apps]);


    // MY SFT
    const setMySftActive = (value) => {
        mySftActive = value;
        isUpdated = true;
    }
    const setUserManagementActive = (value) => {
        userManagementActive = value;
        isUpdated = true;
    }
    const setShippingLogActive = (value) => {
        shippingLogActive = value;
        isUpdated = true;
    }
    const setMobileActive = (value) => {
        mobileActive = value;
        isUpdated = true;
    }
    const setExcelActive = (value) => {
        excelActive = value;
        isUpdated = true;
    }
    const setSchedulerActive = (value) => {
        schedulerActive = value;
        isUpdated = true;
    }
    const setCustomerDisplayActive = (value) => {
        customerDisplayActive = value;
        isUpdated = true;
    }
    const setAiActive = (value) => {
        aiActive = value;
        isUpdated = true;
    }
    const setEticketActive = (value) => {
        eticketActive = value;
        isUpdated = true;
    }
    const setPeppolActive = (value) => {
        peppolActive = value;
        isUpdated = true;
    }
    const setBirthdayActive = (value) => {
        birthdayActive = value;
        isUpdated = true;
    }
    const setIntegrationsActive = (value) => {
        integrationsActive = value;
        isUpdated = true;
    }
    const setMailIntegrationsActive = (value) => {
        mailIntegrationsActive = value;
        isUpdated = true;
    }
    const setLicenceActive = (value) => {
        licenceActive = value;
        isUpdated = true;
    }
    const setRmaActive = (value) => {
        rmaActive = value;
        isUpdated = true;
    }
    const setWebshopActive = (value) => {
        webshopActive = value;
        isUpdated = true;
    }
    const setExactActive = (value) => {
        exactActive = value;
        isUpdated = true;
    }
    // REVENUE APP
    const setRevenueAppActive = (value) => {
        revenueAppActive = value;
        isUpdated = true;
    }

    // Form submit
    const handleSubmit = () => {
        if(!props.defaults){
            let postData = {
                key: props.api,
                user_id: params.userId,
                app_id: params.appId,
                
                my_sft_active: mySftActive,
                revenue_app_active: revenueAppActive,

                my_sft_json: generateJsonMySft(),
                revenue_app_json: revenueAppJson
            }
            
            SftGlobalData.post(params.appId === "apps" ? 'account&action=updateApps' : 'account&action=updateApp', postData).then(response => {
                if(response.status === 200){
                    props.notify(props.t('savedChanges'), 7500, "top-right", props.theme, 1);
                } else {
                    props.notify(props.t('errorOccured') + " " + response?.data?.message, 7500, "top-right",props.theme, 1); 
                }
            });
            isUpdated = false;
        } else {
            let postData = {
                key: props.api,
                my_sft_active: mySftActive,
                revenue_app_active: revenueAppActive,

                my_sft_json: generateJsonMySft(),
                revenue_app_json: revenueAppJson
            }
            SftGlobalData.post('appDefaults&action=update', postData).then(response => {
                if(response.status === 200){
                    props.notify(props.t('savedChanges'), 7500, "top-right", props.theme, 1);
                } else {
                    props.notify(props.t('errorOccured') + " " + response?.data?.message, 7500, "top-right", props.theme, 1); 
                }
            });
                isUpdated = false;
        }
    };


    const getApps = () => {
        if(apps.length > 0){
            if(SftGlobalData.debug){
                console.log("applicationsmapper", apps);
            }
            
            
            return apps.map(app => {
                console.log('app', app);
                console.log('appId', app.id);
                let containerImage = testLogo;
                let content = (<div></div>);
                let containerFunc = (val) => {};
                switch(app.id){
                    case 1:
                    case "1":
                        //console.log('modules', app.settings.modules);
                        containerFunc = (val) => {setMySftActive(val);};
                        mySftActive = app.user_active == "1";
                        containerImage = ic_mysft;

                        // Initialize all module states from settings
                        aiActive = app.settings?.modAi === 1;
                        customerDisplayActive = app.settings?.modCustomerDisplay === 1;
                        eticketActive = app.settings?.modEticket === 1;
                        excelActive = app.settings?.modExcel === 1;
                        mobileActive = app.settings?.modMobile === 1;
                        peppolActive = app.settings?.modPeppol === 1;
                        schedulerActive = app.settings?.modScheduler === 1;
                        shippingLogActive = app.settings?.modShipping === 1;
                        userManagementActive = app.settings?.modUserManagement === 1;
                        birthdayActive = app.settings?.modBirthday === 1;
                        integrationsActive = app.settings?.modIntegrations === 1;
                        mailIntegrationsActive = app.settings?.modMailIntegrations === 1;
                        licenceActive = app.settings?.modLicence === 1;
                        rmaActive = app.settings?.modRma === 1;
                        webshopActive = app.settings?.modWebshop === 1;
                        exactActive = app.settings?.modExact === 1;

                        console.log("DEBUGGG2", app);
                        if(props?.db?.db_id === 179 || props?.db?.db_id === 487){
                            content = (
                                <>
                                    {app.settings?.modAi !== undefined && <CardSliderWithImage changeActive={(val)=>{setAiActive(val)}} active={(app.settings?.modAi === 1)} noClick={true} title={"A.I."} image={geminiLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modBirthday !== undefined && <CardSliderWithImage changeActive={(val)=>{setBirthdayActive(val)}} active={app.settings?.modBirthday === 1} noClick={true} title={"Birthday SMS"} image={birthdayLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modCustomerDisplay !== undefined && <CardSliderWithImage changeActive={(val)=>{setCustomerDisplayActive(val)}} active={app.settings?.modCustomerDisplay === 1} noClick={true} title={"Customer Display"} image={customerDisplayLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modEticket !== undefined && <CardSliderWithImage changeActive={(val)=>{setEticketActive(val)}} active={app.settings?.modEticket === 1} noClick={true} title={"E-ticket"} image={eticketLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modExact !== undefined && <CardSliderWithImage changeActive={(val)=>{setExactActive(val)}} active={app.settings?.modExact === 1} noClick={true} title={"Exact Online"} image={exactLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modExcel !== undefined && <CardSliderWithImage changeActive={(val)=>{setExcelActive(val)}} active={app.settings?.modExcel === 1} noClick={true} title={"Excel"} image={excelLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modIntegrations !== undefined && <CardSliderWithImage changeActive={(val)=>{setIntegrationsActive(val)}} active={app.settings?.modIntegrations === 1} noClick={true} title={"Integrations"} image={integrationsLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modLicence !== undefined && <CardSliderWithImage changeActive={(val)=>{setLicenceActive(val)}} active={app.settings?.modLicence === 1} noClick={true} title={"Licence Module"} image={licenceIcon} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modMailIntegrations !== undefined && <CardSliderWithImage changeActive={(val)=>{setMailIntegrationsActive(val)}} active={app.settings?.modMailIntegrations === 1} noClick={true} title={"Mail Integrations"} image={mailIntegrationsLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modMobile !== undefined && <CardSliderWithImage changeActive={(val)=>{setMobileActive(val)}} active={app.settings?.modMobile === 1} noClick={true} title={"MyFasMan Mobile"} image={mobileLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modPeppol !== undefined && <CardSliderWithImage changeActive={(val)=>{setPeppolActive(val)}} active={app.settings?.modPeppol === 1} noClick={true} title={"Peppol"} image={peppolLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modRma !== undefined && <CardSliderWithImage changeActive={(val)=>{setRmaActive(val)}} active={app.settings?.modRma === 1} noClick={true} title={"RMA"} image={rmaLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modScheduler !== undefined && <CardSliderWithImage changeActive={(val)=>{setSchedulerActive(val)}} active={app.settings?.modScheduler === 1} noClick={true} title={"Scheduler"} image={schedulerLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modShipping !== undefined && <CardSliderWithImage changeActive={(val)=>{setShippingLogActive(val)}} active={app.settings?.modShipping === 1} noClick={true} title={"Shipping"} image={shippingIcon} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modUserManagement !== undefined && <CardSliderWithImage changeActive={(val)=>{setUserManagementActive(val)}} active={app.settings?.modUserManagement === 1} noClick={true} title={"User Management"} image={usersLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modWebshop !== undefined && <CardSliderWithImage changeActive={(val)=>{setWebshopActive(val)}} active={app.settings?.modWebshop === 1} noClick={true} title={"Webshop"} image={webshopLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                </>
                            );
                        } else {
                            content = (
                                <>
                                    {app.settings?.modAi !== undefined && <CardSliderWithImage changeActive={(val)=>{setAiActive(val)}} active={(app.settings?.modAi === 1)} noClick={true} title={"A.I."} image={geminiLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modBirthday !== undefined && <CardSliderWithImage changeActive={(val)=>{setBirthdayActive(val)}} active={app.settings?.modBirthday === 1} noClick={true} title={"Birthday SMS"} image={birthdayLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modCustomerDisplay !== undefined && <CardSliderWithImage changeActive={(val)=>{setCustomerDisplayActive(val)}} active={app.settings?.modCustomerDisplay === 1} noClick={true} title={"Customer Display"} image={customerDisplayLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modEticket !== undefined && <CardSliderWithImage changeActive={(val)=>{setEticketActive(val)}} active={app.settings?.modEticket === 1} noClick={true} title={"E-ticket"} image={eticketLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modExact !== undefined && <CardSliderWithImage changeActive={(val)=>{setExactActive(val)}} active={app.settings?.modExact === 1} noClick={true} title={"Exact Online"} image={exactLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modExcel !== undefined && <CardSliderWithImage changeActive={(val)=>{setExcelActive(val)}} active={app.settings?.modExcel === 1} noClick={true} title={"Excel"} image={excelLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modIntegrations !== undefined && <CardSliderWithImage changeActive={(val)=>{setIntegrationsActive(val)}} active={app.settings?.modIntegrations === 1} noClick={true} title={"Integrations"} image={integrationsLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modLicence !== undefined && <CardSliderWithImage changeActive={(val)=>{setLicenceActive(val)}} active={app.settings?.modLicence === 1} noClick={true} title={"Licence Module"} image={licenceIcon} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modMailIntegrations !== undefined && <CardSliderWithImage changeActive={(val)=>{setMailIntegrationsActive(val)}} active={app.settings?.modMailIntegrations === 1} noClick={true} title={"Mail Integrations"} image={mailIntegrationsLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modMobile !== undefined && <CardSliderWithImage changeActive={(val)=>{setMobileActive(val)}} active={app.settings?.modMobile === 1} noClick={true} title={"MyFasMan Mobile"} image={mobileLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modPeppol !== undefined && <CardSliderWithImage changeActive={(val)=>{setPeppolActive(val)}} active={app.settings?.modPeppol === 1} noClick={true} title={"Peppol"} image={peppolLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modRma !== undefined && <CardSliderWithImage changeActive={(val)=>{setRmaActive(val)}} active={app.settings?.modRma === 1} noClick={true} title={"RMA"} image={rmaLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modScheduler !== undefined && <CardSliderWithImage changeActive={(val)=>{setSchedulerActive(val)}} active={app.settings?.modScheduler === 1} noClick={true} title={"Scheduler"} image={schedulerLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modShipping !== undefined && <CardSliderWithImage changeActive={(val)=>{setShippingLogActive(val)}} active={app.settings?.modShipping === 1} noClick={true} title={"Shipping"} image={shippingIcon} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modUserManagement !== undefined && <CardSliderWithImage changeActive={(val)=>{setUserManagementActive(val)}} active={app.settings?.modUserManagement === 1} noClick={true} title={"User Management"} image={usersLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                    {app.settings?.modWebshop !== undefined && <CardSliderWithImage changeActive={(val)=>{setWebshopActive(val)}} active={app.settings?.modWebshop === 1} noClick={true} title={"Webshop"} image={webshopLogo} theme={props.theme} type={"mysft"} lang={props.lang} userId={params.userId} appId={params.appId} />}
                                </>
                            )
                        }
                        
                    break;
                    case 2:
                    case "2":
                        containerFunc = (val) => {setRevenueAppActive(val);};
                        revenueAppActive = app.user_active == "1";
                        containerImage = ic_revenue;
                        content = (
                            <RevenueSettingsForm api={props.api} theme={props.theme} setJson={(val)=>setRevenueAppJson(val)} settings={app.settings}/>
                        );
                        break;
                    default:
                        containerImage = testLogo;
                        content = (<div></div>);
                        break;
                }

                //console.log(content);

                return (
                    <div key={app.id}>
                        <ApplicationContainer icon={containerImage} title={app.description} appId={parseInt(app.id)} active={app.user_active==="1"} theme={props.theme} t={props.t} func={containerFunc}>
                            {content}
                            <hr/>
                        </ApplicationContainer>
                    </div>
                )
            });
        } else {
            return (<div></div>);
        }
    }

    const confirmAction = () => {
        if(isUpdated === true){
            let confirmAction = window.confirm(props.t('save_changes_question'));
            if (confirmAction) {
                navigate(props.defaults ? "/"+props.lang+"/users" : "/"+props.lang+"/user-detail/"+params.userId);
            } 
        } else {
            navigate(props.defaults ? "/"+props.lang+"/users" : "/"+props.lang+"/user-detail/"+params.userId);
        }
      }

    return (
            <div className={(props.screenWidth) < 600 ? 'not_expanded container_content _80perc ' + props.theme + ' container_content_' + props.theme : 'expanded container_content _80perc ' + props.theme + ' container_content_' + props.theme} >
                <FloatingBackButton disabled={false} onClick={()=>{confirmAction()}} />
                <FloatingSaveButton disabled={loading} onClick={()=>{handleSubmit();}} />
                <div className={"container_list__title " + props.theme}><h2>{props.t('users')} {props.t('settings')}</h2></div>
                <form>
                    {loading && <div className={"container_list__title " + props.theme} style={{display:"flex", justifyContent: "space-evenly", marginTop: 5, border: 1}}>
                        <TailSpin 
                            height="40"
                            width="40"
                            color={Colors.sft_blue}
                            ariaLabel='loading'
                        />
                    </div>} 

                    {!loading && getApps()}
                </form>
            </div>
    );
}

export default UserDetailAppScreen;
